import HandleErrorApi from "./HandleErrorApi";

class ProjectApi {
    api = new HandleErrorApi()

    getProjectList()
    {
        return this.api.get('/projects')
    }

    createProject(data)
    {
        return this.api.post('/projects', data)
    }

    saveProjectChartSettings(data)
    {
        return this.api.post('/projects/settings/chart', data)
    }

    onChangeProjectName(data)
    {
        return this.api.post('/projects/changeName', data);
    }

    onDeleteProject(data)
    {
        return this.api.post('/projects/delete', data);
    }

    saveCompetitorChartSettings(data)
    {
        return this.api.post('/projects/competitors/settings/chart', data)
    }

    switchCompetitorParam(data)
    {
        return this.api.post('/projects/competitors/settings/param', data)
    }

    saveCompetitorChartOrder(data)
    {
        return this.api.post('/projects/competitors/settings/order', data)
    }

    updateCompetitors(data)
    {
        return this.api.post('/projects/competitors', data)
    }

    getProjectParams(data)
    {
        return this.api.get('/projects/competitors', data)
    }

    /**
     * Получаем данные для графиков сравнения конкурентов по периоду
     */
    getProjectParamsByPeriod(data = {projectId: null, dateRange: null})
    {
        return this.api.get('projects/competitors/by-period', data);
    }

    compareDomains(data)
    {
        return this.api.post('/projects/competitors/compare', data)
    }

    onSaveNotificationsSettings(data)
    {
        return this.api.post('/projects/settings/notifications', data);
    }

    setProjectPosition(data)
    {
        return this.api.post('/projects/position', data);
    }

    getRecommendedCompetitors(data)
    {
        return this.api.get('/projects/recommended-competitors', data)
    }

    reloadImage(data)
    {
        return this.api.post('/projects/reload-image', data);
    }

    isFreeAvailable()
    {
        return this.api.get('projects/is-free-available');
    }

    /**
     * Получаем данные для графика по периоду
     */
    getChartDataByPeriod(data = {base: '', projectId: null, dateRange: null})
    {
        return this.api.get('projects/get-chart-data-by-period', data);
    }
}

export default new ProjectApi();
